import toast from "react-hot-toast"
import React, { ReactNode } from "react"

const Toast = React.lazy(() => import("./../components/toast"))

export const toastMsg = (
  msg: string | ReactNode,
  variant: "error" | "info" | "success" = "error",
  duration: number = 10000
) => {
  toast.custom(
    t => (
      <Toast
        id={t.id}
        visible={t.visible}
        message={msg}
        variant={variant}
        height={t.height}
        position={t.position}
      />
    ),
    {
      duration: duration,
    }
  )
}
